export const domain = 'pixuverse.com';
export const apiUrl = 'https://pcats.pixuverse.com';
